import React, { useEffect, useState, useRef } from 'react';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { env } from '../../config/env';

gsap.registerPlugin(ScrollTrigger);

const Metrics = () => {
  const [metrics, setMetrics] = useState({
    solPrice: '€0',
    solCount: '11 885',
    netAssetValue: '€1665 801,60',
    alaloPrice: '€0.0006',
    alaloMarketCap: '€1 996 589,34',
    alaloReturn: '$000',
    mnav: '00.00',
    solOneMonth: '-1,74%'
  });

  const sectionRef = useRef(null);
  const lineRef = useRef(null);

  useEffect(() => {
    if (lineRef.current) {
      gsap.to(lineRef.current, {
        width: '100%',
        duration: 1.5,
        ease: 'power3.out',
        scrollTrigger: {
          trigger: lineRef.current,
          start: 'top 80%',
          toggleActions: 'play none none none'
        }
      });
    }

    // Appel de ton API backend
    const fetchCryptoData = async () => {
      try {
        const res = await fetch(`${env.API_URL}/market/metrics`);
        const data = await res.json();
        setMetrics(data);
      } catch (error) {
        console.error('Erreur lors de la récupération des métriques:', error);
      }
    };

    fetchCryptoData();

    return () => {
      ScrollTrigger.getAll().forEach(trigger => trigger.kill());
    };
  }, []);

  return (
    <section id="metrics-section" className="section_metrics" ref={sectionRef}>
      <div className="padding-global">
        <div className="container-large">
          <div data-horizontal-line-anim="true" className="horizontal-line" ref={lineRef} style={{ width: '0%' }}></div>
          <div className="spacer-1-5"></div>
          <h2>SOL Treasury Corp Metrics</h2>
          <div className="spacer-5"></div>
          <div className="grid is-metrics">
            {/* Métriques statiques */}
            <div className="metric_component">
              <div className="text-size-small">
                <div className="typeface-dm-mono">
                  <div className="text-style-allcaps">
                    <div>solana price</div>
                  </div>
                </div>
              </div>
              <div className="heading-style-h1">
                <div data-sol-price="true">{metrics.solPrice}</div>
              </div>
            </div>
            <div className="metric_component">
              <div className="text-size-small">
                <div className="typeface-dm-mono">
                  <div className="text-style-allcaps">
                    <div>SOL treasury corp SOL Count</div>
                  </div>
                </div>
              </div>
              <div className="heading-style-h1">
                <div>{metrics.solCount} <sup>SOL</sup></div>
              </div>
            </div>
            <div className="metric_component">
              <div className="text-size-small">
                <div className="typeface-dm-mono">
                  <div className="text-style-allcaps">
                    <div>net asset value</div>
                  </div>
                </div>
              </div>
              <div className="heading-style-h1">
                <div data-net-asset-value="true">{metrics.netAssetValue}</div>
              </div>
            </div>
            <div className="metric_component">
              <div className="text-size-small">
                <div className="typeface-dm-mono">
                  <div className="text-style-allcaps">
                    <div>ALALO share price</div>
                  </div>
                </div>
              </div>
              <div className="heading-style-h1">
                <div data-alalo-price="true">{metrics.alaloPrice}</div>
              </div>
            </div>
            <div className="metric_component">
              <div className="text-size-small">
                <div className="typeface-dm-mono">
                  <div className="text-style-allcaps">
                    <div>ALALO market cap</div>
                  </div>
                </div>
              </div>
              <div className="heading-style-h1">
                <div data-alalo-market-cap="true">{metrics.alaloMarketCap}</div>
              </div>
            </div>
            <div className="metric_component">
              <div className="text-size-small">
                <div className="typeface-dm-mono">
                  <div className="text-style-allcaps">
                    <div>ALALO 1 month return</div>
                  </div>
                </div>
              </div>
              <div className="heading-style-h1">
                <div className="text-color-success">
                  <div>{metrics.alaloReturn}</div>
                </div>
              </div>
            </div>
            <div className="metric_component">
              <div className="text-size-small">
                <div className="typeface-dm-mono">
                  <div className="text-style-allcaps">
                    <div>mnav</div>
                  </div>
                </div>
              </div>
              <div className="heading-style-h1">
                <div data-mnav="true">{metrics.mnav}</div>
              </div>
            </div>
            <div className="metric_component">
              <div className="text-size-small">
                <div className="typeface-dm-mono">
                  <div className="text-style-allcaps">
                    <div>solana 1 month return</div>
                  </div>
                </div>
              </div>
              <div className="heading-style-h1">
                <div data-sol-one-month="true">{metrics.solOneMonth}</div>
              </div>
            </div>

            {/* Affichage dynamique des cryptomonnaies de l'API */}
            {/* {cryptoData.map((crypto) => (
              <div className="metric_component" key={crypto.id}>
                <div className="text-size-small">
                  <div className="typeface-dm-mono">
                    <div className="text-style-allcaps">
                      <div>{crypto.name}</div>
                    </div>
                  </div>
                </div>
                <div className="heading-style-h1">
                  {crypto.current_price === 0 ? (
                    <div className="text-color-success">
                      <div>${crypto.current_price.toLocaleString()}</div>
                    </div>
                  ) : (
                    <div>${crypto.current_price.toLocaleString()}</div>
                  )}
                </div>
              </div>
            ))} */}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Metrics;